import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ReplaySubject } from 'rxjs';

import { AffiliateService } from '@www-src/app/core/affiliate.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class RouteLanguageService {
  routeLanguage = new ReplaySubject<string>(1);
  private affiliateService = inject(AffiliateService);
  private cookieService = inject(CookieService);
  private isRouteLanguageSet = false;

  constructor(private router: Router) { }

  updateRouteLanguage(language: string): void {
    if (!this.isRouteLanguageSet) {
      const langExist = this.affiliateService.isLanguageExist(language);
      const cookieLang = this.cookieService.get('locale');
      const locale = this.router.url.split('/')[1];
      
      this.isRouteLanguageSet = true;
      this.routeLanguage.next(langExist && language ? language : cookieLang ? cookieLang : 'en');

      if (locale === 'en') {
        this.router.navigate([this.router.url.replace(`/${locale}`, '')]);
      }
    }
  }
}